<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('permissions')">Uprawnienia</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> Nowe uprawnienie
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="store" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nazwa" />

          <multiselect-input v-model="form.guard_name" :error="form.errors.guard_name" class="pr-6 pb-8 w-full lg:w-1/2" label="Przestrzeń" :options="guard_options" :multiple="false" :close_on_select="true" />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center rounded-b-md">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Stwórz uprawnienie</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Nowe uprawnienie' },
  components: {
    LoadingButton,
    TextInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
        guard_name: 'web'
      }),
      guard_options: ['web', 'api']
    }
  },
  methods: {
    store() {
      this.form.post(this.route('permissions.store'))
    },
  }
}
</script>
